export enum ScrollDirection {
  Up = 'Up',
  Down = 'Down',
}
